export const PAGE_SCOPE = 'page';
export const ORDER_SCOPE = 'order';
export const ITEM_SCOPE = 'item';
export const ITEM_GROUP_SCOPE = 'itemGroup';
